let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kl1cO"), load("diQ7c")]).then(() => parcelRequire('e83j3'));